export enum Status {
  IDLE = "idle",
  STARTING = "starting",
  RUNNING = "running",
  DONE = "done",
  ERROR = "error",
  CANCELLED = "cancelled",
  SAVING = "saving",
  SAVED = "saved",
}

export const STATUS_CONFIG = {
  [Status.IDLE]: { icon: "CircleOutlined", color: "default", label: "Ready" },
  [Status.STARTING]: { icon: "CircularProgress", color: "warning", label: "Starting" },
  [Status.RUNNING]: { icon: "CircularProgress", color: "warning", label: "Running" },
  [Status.DONE]: { icon: "CheckCircle", color: "success", label: "Done" },
  [Status.ERROR]: { icon: "Error", color: "error", label: "Error" },
  [Status.CANCELLED]: { icon: "Error", color: "error", label: "Cancelled" },
  [Status.SAVING]: { icon: "CircularProgress", color: "primary", label: "Saving" },
  [Status.SAVED]: { icon: "CheckCircle", color: "success", label: "Saved" },
} as const;

export const isActive = (status: Status) =>
  status === Status.STARTING || status === Status.RUNNING || status === Status.SAVING;

export const isComplete = (status: Status) =>
  status === Status.DONE ||
  status === Status.ERROR ||
  status === Status.CANCELLED ||
  status === Status.SAVED;

export const mapLegacyStatus = (status: string): Status => {
  switch (status.toLowerCase()) {
    case "pending":
    case "queued":
    case "init":
    case "starting":
      return Status.STARTING;
    case "in_progress":
    case "running":
      return Status.RUNNING;
    case "completed":
    case "success":
    case "done":
      return Status.DONE;
    case "failed":
    case "error":
      return Status.ERROR;
    case "cancelled":
      return Status.CANCELLED;
    case "saving":
      return Status.SAVING;
    case "saved":
      return Status.SAVED;
    default:
      return Status.IDLE;
  }
};
